module.exports = __webpack_public_path__ + "static/img/Frame21.f897d44e.png";